/**
 * @param {jQuery} $
 * @param {AppConfig} config
 * @param {AppLibrary} library
 * @param {TabInfo} tabInfo
 * @param {TabStats} tabStats
 * @param {TabHistory} tabHistory
 * @param {TabTerms} tabTerms
 * @constructor
 */
export let Tabs = function ($, config, library, tabInfo, tabStats, tabHistory, tabTerms) {
  /**
   * @type {string}
   */
  let template = `
<div class="slp-tabs">
    <div class="slp-tabs-heading">
      <h1>{{title}}</h1>
    </div>
    <div class="slp-tabs-titles">
        {{#tabs}}
            <div class="slp-tabs-title {{#open}}active{{/open}}" data-spl-tab-title="{{id}}">
                {{&title}}
            </div>
        {{/tabs}}
       <div class="slp-tabs-slide"></div>
    </div>
    <div class="slp-tabs-bodies">
        {{#tabs}}
            <div class="slp-tabs-body {{#open}}active{{/open}}" data-spl-tab-body="{{id}}">
                {{&body}}
            </div>
        {{/tabs}}
    </div>
</div>
`;

  /**
   * @type {{info: TabInfo, stats: TabStats, history: TabHistory, terms: TabTerms}}
   */
  let tabObjects = {
    info: tabInfo,
    stats: tabStats,
    history: tabHistory,
    terms: tabTerms,
  };

  /**
   * @param {HTMLElement} container
   * @param {[string]} tabTypes
   * @return {string}
   */
  this.render = (container, tabTypes) => {
    let tabsData = [];
    tabTypes.forEach((tabType) => {
      if (typeof(tabObjects[tabType]) === 'undefined') {
        throw new Error('Tab type "' + tabType + '" is not exists. Available types: ' + Object.keys(tabObjects).join(', '));
      }
      tabsData.push({
        id: tabType,
        title: tabObjects[tabType].getTitle(),
        body: tabObjects[tabType].getBody(),
        open: tabsData.length === 0
      });
    });

    container.innerHTML = library.mustache().render(
      config.customization().tabsTemplate || template,
      {
        tabs: tabsData,
        title: config.getTexts().badge.title,
      }
    );

    initBehaviour(container);

    tabTypes.forEach((tabType) => {
      tabObjects[tabType].afterDisplay(container);
    });
  };

  /**
   * @param {HTMLElement} container
   */
  function initBehaviour(container) {
    let $container = $(container),
      tabs = $container.find('[data-spl-tab-title]'),
      slide = $container.find('.slp-tabs-slide'),
      count = tabs.length;
    slide.css({
      width: 'calc(100% / ' + count + ')'
    });
    tabs.click(function () {
      let $this = $(this);
      if ($this.hasClass('active')) {
        return;
      }
      $container.find('[data-spl-tab-title].active').removeClass('active');
      $this.addClass('active');
      slide.css({
        left: 'calc((100% / ' + count + ') * ' + $this.index() + '',
      });
      let tabId = this.getAttribute('data-spl-tab-title');
      $container.find('[data-spl-tab-body].active').removeClass('active');
      $container.find('[data-spl-tab-body="' + tabId + '"]').addClass('active');
    });
  }
};